import { styled } from '@clickcease/cc-client-components-lib'

export const ModifyPlanBoxSummaryStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$12',
})

export const ModifyPlanBoxSummaryTitle = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  cursor: 'pointer',
  marginBottom: '$8',
})

export const ModifyPlanBoxSummaryTitleText = styled('span', {})

export const ModifyPlanBoxSummaryList = styled('div', { display: 'flex', flexDirection: 'column' })

export const ModifyPlanBoxSummarySeparator = styled('div', {
  width: '100%',
  margin: '$1 0px $1 0px',
  background: '$primaryColor',
  height: '1px',
})

export const ModifyPlanBoxSummaryListItem = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '$2',

  variants: {
    outstanding: {
      true: {
        marginTop: '$2',
      },
    },
    spaceAfter: {
      true: {
        marginBottom: '$2',
      },
    },
  },
})

export const ModifyPlanBoxSummaryListItemName = styled('span', {
  fontSize: '$md',
  marginRight: '$2',
  variants: {
    outstanding: {
      true: {
        fontWeight: '$sb',
      },
    },
  },
})
export const ModifyPlanBoxSummaryListItemPrice = styled('span', {
  fontSize: '$md',
  variants: {
    outstandingPrice: {
      true: {
        fontWeight: '$sb',
      },
      false: {
        fontWeight: '$r',
      },
    },
  },
})
